module.exports = __webpack_public_path__ + "app/img/cartouche_EGPAir.9aa82e87.jpg";